import { render, staticRenderFns } from "./dev-debug.vue?vue&type=template&id=483d8d0f"
import script from "./dev-debug.vue?vue&type=script&lang=ts"
export * from "./dev-debug.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports